import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useInvalidate, useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Partner } from "@modules/partners/types";
import { PartnerFormValues } from "@modules/partners/validations";

import { editPartnerService } from "./service";
import { UseEditPartnerMutationOptions } from "./types";
import { getPartnerQueryKey } from "../../queries/getPartner/query";

export function useEditPartnerMutation(
  id: number | string,
  options?: UseEditPartnerMutationOptions
) {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();
  const invalidate = useInvalidate();

  return useMutation<Partner, ApiError, Partial<PartnerFormValues>>({
    mutationFn: (data) => editPartnerService(id, data),
    onSuccess: () => {
      // tabela usa useList do refine; a key dele não começa com listPartnersQueryKey
      invalidate({ resource: "v1/partner_admin", invalidates: ["list"] });
      queryClient.invalidateQueries({
        queryKey: getPartnerQueryKey(id),
        refetchType: "all",
      });
      open?.({ type: "success", message: translate("v1/partner_admin.success.edit") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
    ...options,
  });
}
